<template>
  <MenuComponent/>
  <main class="home main-container" style="display: flex; padding: 0 15px;">
    <!-- <img src="/assets/img/logo_turri.png" style="max-width: 250px;" alt="Logo TurriSystem"/> -->
    <h1 class="heading--1 font-signautre">Tesoreria del Tolima</h1>
  </main>
</template>

<script>
import MenuComponent from "@/layouts/MenuComponent";
import {useRouter} from "vue-router";

/**
 Componente de la página de inicio.
 @name HomePage
 @component
 @example
 <HomePage />
 */
export default {
  name: "HomePage",
  components: {MenuComponent},
  /**
    Método que se ejecuta después de que se carga el componente.
    Si el usuario está autenticado, redirige a la página de inicio.
    @function mounted
    @memberof HomePage
    @returns {void}
    */
  mounted() {
    const router = useRouter();
    const isLogged = document.cookie.indexOf('token') !== -1;
    if (isLogged) router.push('/inicio');
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/main.scss";

.home {
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__heading {
    font-size: 3rem;
    color: $color__primary;
    margin-bottom: 2rem;
  }

  &__btn {
    @include customBorder(transparent, $color__primary);
    color: $color__primary;
    padding: 1rem 4rem;
    border-radius: 4px;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      @include customBorder($color__primary, #fff);
      color: #fff;
    }

    &:active,
    &:focus {
      outline: none;
    }
  }
}
</style>
